package org.gstechnovos.jexonplastech.sections.products.styles

import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.focus
import com.varabyte.kobweb.silk.style.selectors.hover
import org.gstechnovos.jexonplastech.theme.toSitePalette
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import kotlin.time.Duration.Companion.milliseconds

val FilterContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .padding(topBottom = 40.px)
    }
}

val FilterButtonStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier
            .padding(leftRight = 24.px, topBottom = 10.px)
            .borderRadius(30.px)
            .border(2.px, LineStyle.Solid, palette.brand.primaryBlue)
            .color(palette.brand.primaryBlue)
            .backgroundColor(palette.custom.white)
            .cursor(Cursor.Pointer)
            .fontWeight(com.varabyte.kobweb.compose.css.FontWeight.Medium)
            .fontSize(16.px)
            .transition(
                Transition.of("background-color", 0.3.s),
                Transition.of("color", 0.3.s),
                Transition.of("transform", 0.2.s)
            )
    }
    hover {
        Modifier
            .backgroundColor(palette.brand.primaryBlueHover)
            .border(2.px, LineStyle.Solid, palette.brand.primaryBlueHover)
            .color(palette.custom.white)
            .translateY((-2).px)
    }
}

// ==========================================
// STYLES
// ==========================================
val SearchInputStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette()
        Modifier
            // 1. Use darkText with 30% opacity so the border is clearly visible but still subtle
            .border(1.px, LineStyle.Solid, palette.custom.darkText.toRgb().copyf(alpha = 0.3f))
            .outline(0.px) // 2. Force removal of the default browser focus ring
            .backgroundColor(palette.custom.white) // 3. Keep the inside white
            .transition(Transition.of(TransitionProperty.All, duration = 300.ms))
    }
    focus {
        val palette = colorMode.toSitePalette()
        Modifier
            // 4. Change to your primary brand color when the user clicks inside
            .border(1.px, LineStyle.Solid, palette.brand.primaryBlue)
            // Optional: Adds a subtle blue glow around the input when focused
            .boxShadow(0.px, 0.px, 0.px, 3.px, palette.brand.primaryBlue.toRgb().copyf(alpha = 0.15f))
    }
}